<template>
  <div>
    <input
        :id="'checkbox' + id"
        class="checkbox"
        type="checkbox"
        :checked="modelValue"
        @change="onChange"
    >
    <label :for="'checkbox' + id" class="checkbox__label">
      <slot />
    </label>
  </div>
</template>

<script setup>
const emit = defineEmits(['update:modelValue'])
defineProps({
  id: [Number, String],
  modelValue: Boolean
})

const onChange = (event) => {
  emit('update:modelValue', event.target.checked)
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: none;
  opacity: 0;

  &__label {
    color: #F3F3F3;
    font-size: 20px;
  }
}

.checkbox + .checkbox__label::before {
  content: '';
  display: inline-block;
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  flex-grow: 0;
  border-radius: 2px;
  border: 1px solid $white;
  background-color: transparent;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.checkbox:checked + .checkbox__label::before {
  border-color: #ff0000;
}

.checkbox + .checkbox__label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  user-select: none;
}
</style>